export class Template {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {string} */
    subject = '';
    /** @type {string} */
    content = '';

    /** @type {string} */
    type = '';

    /**
     * @param {Object} obj
     * @returns {Template}
     */
    static fromArray(obj) {
        return Object.assign(new this, obj || {});
    }
}